export default "/images/7dedeab9f25ce94e40e9f4fab56ab8d0.png";